"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postDislike = exports.postLike = exports.loadFavorites = exports.loadTracks = void 0;
const axios_1 = __importDefault(require("axios"));
const auth_1 = require("./auth");
async function loadTracks(filterString) {
    const response = await axios_1.default.get(`${window.process.env['API_SERVER_URL']}/songs?search=${filterString}`);
    return response.data;
}
exports.loadTracks = loadTracks;
async function loadFavorites() {
    const likesResponse = await axios_1.default.get(`${window.process.env['API_SERVER_URL']}/users/${auth_1.username}/likes`);
    const shortTracks = likesResponse.data.songLikes;
    const tracks = [];
    for (const track of shortTracks) {
        tracks.push(await loadTrack(track.id));
    }
    return tracks;
}
exports.loadFavorites = loadFavorites;
async function loadTrack(id) {
    const response = await axios_1.default.get(`${window.process.env['API_SERVER_URL']}/songs/${id}`);
    return response.data;
}
async function postLike(trackId) {
    await axios_1.default.post(`${window.process.env['API_SERVER_URL']}/songs/${trackId}/like`);
}
exports.postLike = postLike;
async function postDislike(trackId) {
    await axios_1.default.post(`${window.process.env['API_SERVER_URL']}/songs/${trackId}/unlike`);
}
exports.postDislike = postDislike;
